export default __webpack_public_path__ + "static/media/jupiter.8cb10134.png";